// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GfzL","option":"styles_option__3cLGz","active":"styles_active__28sAn"};